import { useFormik } from "formik";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { Button, Grid2, Typography } from "@mui/material";

import ContainerLoadingLogin from "../components/ContainerLoadingLogin";
import { Input } from "../components/Input";

import Logo from "../assets/svg/logo-full.svg";

import { useUserStore } from "../stores/user";
import { login } from "../services/auth";

import { formatPhone, unMask } from "../helpers/format";
import { H } from "highlight.run";

const Login = () => {
  const navigate = useNavigate();
  const { setUser } = useUserStore();

  const { mutate, isPending } = useMutation({
    mutationFn: login,
    onSuccess: (data: any) => {
      if (!["MASTER", "STORE_ADMIN"].includes(data?.user?.role)) {
        toast.info("Entre em contato com a academia para liberar seu acesso.");
        return;
      }

      if (import.meta.env.VITE_APP_ENV === "production") {
        H.identify(data?.user?.email, {
          id: data?.user?.id,
          phone: data?.user?.phone,
          document: data?.user?.document,
        });
      }

      toast.success("Bem-vindo");
      localStorage.setItem("access_token", data?.access_token);
      setUser(data);

      if (data?.user?.role === "MASTER" && data?.user?.store?.needSelectPlan) {
        navigate("/free-period-expired");
      } else {
        navigate("/financeiro");
      }
    },
    onError: () => {
      toast.error("usuário e ou senha inválidos ");
    },
  });

  const { handleChange, values, handleSubmit } = useFormik({
    initialValues: {
      phone: "",
      password: "",
    },
    onSubmit: (values) => {
      if (!values.phone) {
        toast.error("Digite seu telefone");
        return;
      }
      if (!values.password) {
        toast.error("Digite sua senha");
        return;
      }
      mutate({
        username: unMask(values.phone),
        password: values.password,
        web: true,
      });
    },
  });

  return (
    <ContainerLoadingLogin loading={isPending}>
      <Grid2 container sx={styles.container}>
        <Grid2 container sx={styles.paper} spacing={4}>
          <Grid2 size={12}>
            <img src={Logo} alt="" />
          </Grid2>
          <Grid2 size={12}>
            <Typography variant="h4" fontWeight={700}>
              Acesse sua conta
            </Typography>
            <Typography fontWeight={700}>
              Acesso exclusivo para academia
            </Typography>
          </Grid2>
          <Grid2
            container
            size={12}
            spacing={2}
            component="form"
            onSubmit={handleSubmit}
          >
            <Grid2 size={12}>
              <Input
                id="phone"
                name="phone"
                label="Telefone"
                placeholder="Telefone"
                type="tel"
                fullWidth
                value={formatPhone(values.phone)}
                onChange={handleChange}
              />
            </Grid2>
            <Grid2 size={12}>
              <Input
                id="password"
                name="password"
                label="Senha"
                placeholder="Senha"
                type="password"
                fullWidth
                value={values.password}
                onChange={handleChange}
              />{" "}
            </Grid2>
            {/* <Grid2 size={12} my={1}>
              <Stack alignItems={"end"}>
                <Typography
                  fontWeight={700}
                  sx={{
                    cursor: "pointer",
                    "&&:hover": { textDecoration: "underline" },
                  }}
                  onClick={() => navigate("/forgot-password")}
                >
                  Esqueci minha senha
                </Typography>
              </Stack>
            </Grid2> */}
            <Grid2 size={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                sx={{ marginTop: 2 }}
              >
                Entrar
              </Button>
            </Grid2>
            {/* <Grid2 size={12}>
              <Button
                variant="text"
                fullWidth
                size="large"
                onClick={() => navigate("/signup")}
                sx={{ mt: 2, fontSize: 16 }}
              >
                Cadastre sua academia aqui
              </Button>
            </Grid2> */}
          </Grid2>
        </Grid2>
      </Grid2>
    </ContainerLoadingLogin>
  );
};

const styles = {
  paper: {
    width: { md: "40%" },
    backgroundColor: "background.default",
    padding: "2rem",
    borderRadius: "24px",
  },
  avatar: {
    backgroundColor: "blueviolet",
  },

  container: {
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};

export default Login;
